import { useEffect, useState, useContext } from "react";
import axios from "axios";
import NavBar from "../layout/NavBar";
import "../styles/contact.css";
import { Form } from "react-bootstrap";
import { http } from "../auth";
import { ThemeContext } from "../App";
import { useThemeManager } from "../Hooks/ThemeManager";

const Contact = () => {
  const { themeColors } = useThemeManager();
  const token = localStorage.getItem("token");
  const storedDataServ = sessionStorage.getItem('dataServ');
  const [dataUser, setDataUser] = useState(JSON.parse(storedDataServ));
  const [dataContact, setDataContact] = useState(null);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(null);
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(`https://maps.google.com/maps?q=${sedeSeleccionada?.coordenadas}&z=14&t=m&output=embed`);

  const fetchData = () => {
    http
      .get(`/sedes-ver`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDataContact(response.data);
        setSedeSeleccionada(response.data.data[2]);
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
      });
  };

  const handleSelectChange = (event) => {
    const sedeId = Number(event.target.value);
    const sede = dataContact?.data.find(sede => sede.id_sede === sedeId);
    setSedeSeleccionada(sede);
  };

  const handleMap = () => {
    setLoading(true);
    setSrc(`https://maps.google.com/maps?q=${sedeSeleccionada?.coordenadas}&z=14&t=m&output=embed`)
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    handleMap();
  }, [sedeSeleccionada]);


  return (
    <div className="contenedorContacto color-secondary">
      <div className="contactoInformacionContenedor">
        <span className="tituloContacto">Información de contacto</span>
        <div className="contactoSelectContenedor" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span>Seleccione una sede:</span>
          <Form.Select className="contactoSelect border-secondary color-secondary" onChange={handleSelectChange}>
            {dataContact?.data.slice().reverse().map((sede) => (
              <option key={sede.id_sede} value={sede.id_sede}>{sede.nombre}</option>
            ))}
          </Form.Select>
        </div>
        <div className="itemContacto" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span className="itemTitulo">Sede actual:</span>
          <span className="itemSubtitulo">{sedeSeleccionada?.nombre}</span>
        </div>
        <div className="itemContacto" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span className="itemTitulo">Dirección:</span>
          <span className="itemSubtitulo">{sedeSeleccionada?.direccion}</span>
        </div>
        <div className="itemContacto" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span className="itemTitulo">Horario:</span>
          <span className="itemSubtitulo">{sedeSeleccionada?.horario.join(', ')}</span>
        </div>
        <div className="itemContacto" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span className="itemTitulo">Telefono:</span>
          <span className="itemSubtitulo">{sedeSeleccionada?.telefonos.join(', ')}</span>
        </div>
        <div className="itemContacto" style={{borderBottom: '1px solid var(--secondary-color)'}}>
          <span className="itemTitulo">Correo:</span>
          <span className="itemSubtitulo">{sedeSeleccionada?.email.General}</span>
        </div>
      </div>
      <div className="mapaContenedor">
        <div className="mapa">
          {loading ? <div className="contenSpinner" style={{ display: loading ? "flex" : "none" }}>
            <div class="spinner blue"></div>
          </div> :
            <iframe
              width="100%"
              className="iframeMap"
              style={{ border: 0 }}
              loading="eager"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={src}>
            </iframe>}
        </div>
      </div>
    </div>
  )
}

export default Contact;
